import {Office} from "../api/Model";

export const BERLIN_OFFICE_ID: Office['id'] = 272017;
export const MUNICH_OFFICE_ID: Office['id'] = 266186;
export const PRAGUE_OFFICE_ID: Office['id'] = 272012;
export const AMSTERDAM_OFFICE_ID: Office['id'] = 272013;
export const YEREVAN_OFFICE_ID: Office['id'] = 272019;
export const BELGRADE_OFFICE_ID: Office['id'] = 272018;
export const BERLIN_OFFICE_PATH_ELEMENT = `berlin-${BERLIN_OFFICE_ID}`;

export function parseOfficePathElement(officePathElement: string): Office['id'] | null {
    const dashIndex = officePathElement.lastIndexOf('-');
    const officeIdString = dashIndex === -1
        ? officePathElement
        : officePathElement.substring(dashIndex + 1);
    try {
        const officeId = parseInt(officeIdString, 10);
        return Number.isNaN(officeId) ? null : officeId;
    } catch (e) {
        console.warn(`Failed to parse office id from path element ${officePathElement}`, e);
        return null;
    }
}

const spaceRegex = /\s+/g;
export function buildOfficePathElement(office: Office): string {
    return `${office.name.replace(spaceRegex, '-').toLowerCase()}-${office.id}`;
}
